import axios from "axios";

import { IUploadFileRequestData, UploadFileResponse } from "./file.service.d";

export class FileService {
    /**
     * Upload a new file request
     *
     * @param  {ICreateFormRequestData} data
     */
    static async uploadFile(file: IUploadFileRequestData, userId: string, formId: string): UploadFileResponse {
        const formatBeforeSend = (file: IUploadFileRequestData): FormData => {
            const formattedFile = new FormData();
            formattedFile.append("file", file as any);
            return formattedFile;
        };

        const formattedFile = formatBeforeSend(file);

        const headers = {
            Authorization:
                "Bearer sl.BZX4eUyGRmCoRR3lAjokvL5UB6Y5sV_q8BT--zff_WTRwUa_xkIe38R6DxgN_Lqqb5KtIf5GvoiIGi2ml6ZPPSXAX7unkglCKrNysIVFt8shT3pXl9JbdUXyMSTi_92RFZmr8pI",
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
        };
        const folder = `${formId}_${userId}`;

        const uploadResponse = await axios.post(
            `https://storage.apiboomtech.com/file?platform=boomform.com&folder=${folder}`,
            formattedFile,
            {
                headers: headers,
            },
        );

        return uploadResponse.data;
    }
}
